export const guideSteps = [
  {
    step: "01",
    icon: "ri-compass-3-line",
    title: "先明确自己的需求",
    desc: "想第一时间跟热点、想找剧友聊天，还是只想轻松放松？需求不同，适合的群完全不一样。",
  },
  {
    step: "02",
    icon: "ri-pulse-line",
    title: "重点看活跃度而非人数",
    desc: "优先选择工作日白天仍有人对话的群，两千人的活跃群往往比五千人的冷清大群更耐看。",
  },
  {
    step: "03",
    icon: "ri-file-list-3-line",
    title: "翻一翻群规再决定",
    desc: "有明确群规且管理员日常巡查的群，刷屏和广告都更少，长期体验更省心。",
  },
  {
    step: "04",
    icon: "ri-eye-line",
    title: "先潜水三天再长期留下",
    desc: "不要急着发言，观察三天话题质量与氛围，确认合适再设置星标长期关注。",
  },
];

export const guideSections = [
  {
    id: "what-is",
    title: "一、先弄清楚：吃瓜群到底是什么",
    paragraphs: [
      "「吃瓜群」并不是某一类固定产品，而是网友对娱乐资讯讨论群的习惯叫法。它们的共同点是围绕娱乐圈动态、影视热点、网络新鲜事展开聊天，成员之间互相分享线索、讨论事件、补充背景。",
      "正因为门槛低、方向杂，同样叫「吃瓜群」的群组，实际体验可能差得很远。有的群两小时内就能把热点时间线整理清楚，有的群则长期冷清、只剩广告。选群这件事，本质上是在筛选「谁来陪你聊、聊得怎么样」。",
    ],
    tips: "记住一句话：你要选的是「氛围和更新」，而不是「群名听起来够热闹」。",
  },
  {
    id: "needs",
    title: "二、按需求选方向，不要见群就加",
    paragraphs: [
      "加入之前先问自己三个问题：我是想第一时间跟热点，还是想找人聊剧，或者只是下班后放松一下？答案不同，选择的方向也不同。",
      "想跟热点，优先选日更、响应快的综合娱乐群；想找剧友，选有剧集分区、标注剧透规则的追剧群；想放松，则适合生活趣事或搞笑向的群。方向对了，体验就成功了一半。",
    ],
    tips: "同时加入的群建议不超过三个，信息过载会让你很快对所有群都失去兴趣。",
  },
  {
    id: "activity",
    title: "三、判断活跃度：三个可落地的信号",
    paragraphs: [
      "第一个信号是工作日的白天。如果群里白天几乎无人说话，只在深夜冒出零星几条，说明成员粘性不足，很难长期提供有价值的内容。",
      "第二个信号是热点的响应速度。真正的活跃群，会在热点出现后很快有人整理时间线或补充背景；长期无人跟进，基本可以判断为沉寂群。第三个信号是管理员的出现频率，愿意定期维护群规与话题的群，通常更靠谱。",
    ],
    tips: "本站排行中的「活跃度」分值，就是综合消息量、发言人数占比、话题时长和管理频率得出的。",
  },
  {
    id: "avoid",
    title: "四、避坑：这几类群要果断退出",
    paragraphs: [
      "第一类是收费群。任何以入群费、会员费、押金名义提前收钱的，都不是正常交流群，直接退出即可。第二类是拉人头返利群，它们的核心目的是裂变而不是讨论。",
      "第三类是广告与营销号密集的群，尤其是群规形同虚设、无人管理的群。第四类是长期传播未证实爆料、甚至涉及他人隐私的群，这类群不仅信息价值低，还可能带来风险，不建议参与和转发。",
    ],
    tips: "遇到要求提供身份证、银行卡或转账的信息，请立即退出，不要有任何犹豫。",
  },
  {
    id: "habits",
    title: "五、进群后的好习惯",
    paragraphs: [
      "进群先看置顶与群规，改好群昵称，遵守大家公认的规矩，这是融入的第一步。看到感兴趣的话题再发言，比一上来就刷存在感更容易被接纳。",
      "对于未经证实的内容，保持「待证实」的心态，不随意转发到其他平台，也不据此评价当事人。遇到明显违规内容，及时联系管理员，好的群会很快处理。",
    ],
    tips: "把最满意的两三个群设为星标，其余群开免打扰，手机和心情都会清爽很多。",
  },
  {
    id: "review",
    title: "六、定期复盘：该换群时就换群",
    paragraphs: [
      "群是会变化的，今天的活跃群半年后可能变得冷清。建议每隔一段时间简单复盘：这个群最近还提供有用信息吗？氛围是否仍然舒服？如果两条都不满足，换一个更好的群并不可惜。",
      "本站的推荐与排行也会定期复核。长期沉寂、广告泛滥或氛围变差的群会被降级，表现稳定的群则会持续保留在榜单前列，方便你随时找到替代选择。",
    ],
    tips: "选群不是一次性动作，而是一个持续微调的过程。",
  },
];